import { Component, EventEmitter, Input, Output } from '@angular/core';

export type EmptyStateSize = 'sm' | 'md' | 'lg';

/**
 * Estado vacío: icono en círculo, título, texto y (opcionalmente) una acción.
 *
 * Estaba copiado a mano en una docena de pantallas y HABÍA DIVERGIDO en tres familias de
 * tamaño, así que unificarlo a una sola habría movido píxeles en la mayoría:
 *
 *   sm  — icono 80px.  5 pantallas de shop-settings (dominio, analítica, marketing, redes,
 *         monedas). Es la familia más numerosa y por eso es el valor por defecto.
 *   md  — icono 100px. Métodos de envío y de pago. Es la única con media query propia.
 *   lg  — icono 120px. setting-nav y pos-staff, las más antiguas.
 *
 * Nota sobre `lg`: las dos versiones originales llevaban los colores a fuego (azul en
 * setting-nav, VERDE en pos-staff) en vez de tokens. Aquí se tokeniza con `$primary`, así que
 * al migrar pos-staff su círculo verde pasará a azul de marca. Es deliberado: era la única
 * pantalla del backoffice con ese verde.
 *
 * El botón es 0 o 1, nunca dos: así es en las doce pantallas. Para casos con más de una acción
 * queda el `<ng-content>` debajo.
 */
@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {

  /** Icono bootstrap del círculo, p.ej. 'bi bi-truck'. */
  @Input() icon = 'bi bi-inbox';

  /** Clave i18n del título. */
  @Input() title!: string;

  /** Clave i18n del texto de apoyo. Opcional. */
  @Input() text?: string;

  /** Clave i18n del botón. Si no se pasa, no hay botón. */
  @Input() actionLabel?: string;

  @Input() actionIcon = 'bi bi-plus-circle';

  @Input() actionDisabled = false;

  @Input() size: EmptyStateSize = 'sm';

  /**
   * Alto mínimo, por si una pantalla necesita el suyo. Sin esto habría que aceptar que
   * `shop-currencies` (250px) saltara a los 300px de su familia.
   */
  @Input() minHeight?: string;

  @Output() action = new EventEmitter<void>();
}
